
import GwSection from '~/patterns/organisms/section/section.vue';
import GwCardGrid from '~/patterns/molecules/card-grid/card-grid.vue';
import GwCard from '~/patterns/atoms/card/card.vue';
import GwButton from '~/patterns/atoms/button/button.vue';
import GwIcon from '~/patterns/atoms/icon/icon.vue';
import ImageSingle from '~/patterns/atoms/image-single/image-single.vue';

export default {
    components: {
        GwSection,
        GwCardGrid,
        GwCard,
        GwButton,
        GwIcon,
        ImageSingle
    },
    props: {
        trainers: {
            type: Array,
            default: () => { return []; }
        }
    },
    computed: {
        hasTitle() {
            return !!this.$slots.title;
        },
        hasButton() {
            return !!this.$slots.button;
        },
        trainersList() {
            return this.trainers.filter(trainer => trainer.page.length);
        }
    },
    methods: {
        pageUrl(trainer) {
            if (trainer.page.length) {
                return trainer.page[0].url;
            }

            return '';
        }
    }
};
